<template>
  <div v-if="isTester" id="app">
    <ColorMode/>
    <TopMenu v-if="!isAdminRoute" />
    <router-view></router-view>
    <FooterMenu v-if="!isAdminRoute" />
  </div>
  <div v-else class="under-construction-wrapper d-flex align-items-center justify-content-center">
    <div class="text-center p-5">
      <h1 class="display-1 fw-bold text-white">DART CLUB WISŁA</h1>
      <h1 class="display-5 fw-bold text-white">Strona w trakcie aktualizacji.</h1>
      <p class="lead text-white">Zapraszamy wkrótce!</p>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import TopMenu from "@/components/menu/TopMenu.vue";
import ColorMode from "@/components/menu/ColorMode.vue";
import FooterMenu from "@/components/menu/FooterMenu.vue";

export default {
  name: 'App',
  components: {
    FooterMenu,
    ColorMode,
    TopMenu
  },
  data() {
    return {
      isTester: false
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    }
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      const testerCookie = Cookies.get('tester');
      this.isTester = (testerCookie === 'ft123!');
    }
  }
}
</script>

<style>
.under-construction-wrapper {
  background-image: url('../src/assets/banner.jpg');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-color: #000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
